import { render, staticRenderFns } from "./FilePreviewDrawer.vue?vue&type=template&id=7380cd60&scoped=true"
import script from "./FilePreviewDrawer.vue?vue&type=script&lang=js"
export * from "./FilePreviewDrawer.vue?vue&type=script&lang=js"
import style0 from "./FilePreviewDrawer.vue?vue&type=style&index=0&id=7380cd60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7380cd60",
  null
  
)

export default component.exports